export default "__VITE_ASSET__861ea929__"